export enum DirectoryPropertyType {
    Bool = 'bool',
    Float = 'float',
    Json = 'json',
    String = 'string',
}

export type DirectoryProperty = {
    id: string;
    type: DirectoryPropertyType;
    readable: boolean;
    writable: boolean;
};

export type DirectoryNode = {
    id: string;
    properties: DirectoryProperty[];
};

export enum WebSocketStatus {
    Conntected = 'connected',
    Connecting = 'connecting',
    Disconnected = 'disconnected',
}
